import styled from 'styled-components';

import { UploadedFileVideo } from '@/component/FileUpload/types';
import { useFormRecordingVimeoPlayer } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/hooks/useFormRecordingVimeoPlayer';

const RootStyled = styled.div<{ $rounded?: boolean; $localRatio: number }>`
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom-left-radius: ${({ $rounded }) => ($rounded ? '12px' : '4px')};
  border-bottom-right-radius: ${({ $rounded }) => ($rounded ? '12px' : '4px')};
  overflow: hidden;

  /* Ensure the Vimeo player iframe fills the container */
  & iframe {
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    border: none !important;
  }
`;

type FormRecordingVideoPreviewVimeoProps = {
  uploadedFileVideo: UploadedFileVideo;
  rounded?: boolean;
};

export const FormRecordingVideoPreviewVimeo = ({
  uploadedFileVideo,
  rounded,
}: FormRecordingVideoPreviewVimeoProps): JSX.Element => {
  const { videoRef } = useFormRecordingVimeoPlayer({ uploadedFileVideo });
  const localRatio = uploadedFileVideo.ratio || 0.5625;

  return <RootStyled $rounded={rounded} $localRatio={localRatio} ref={videoRef} className="video" />;
};
